import { Fragment, useState } from "react";
import "./App.css";
import "./ui-kit/typography/styles.css";
import AppContainer from "./AppContainer";

import BootOverlay from "./components/BootOverlay";
import useHeldLoading from "./hooks/use-held-loading";
import PublicAuthAPIs from "./PublicAuthAPIs";

function App() {
  const [loading, setLoading] = useState(true);
  const booting = useHeldLoading(loading);

  return (
    <Fragment>
      <PublicAuthAPIs setLoading={setLoading} />
      {!loading && <AppContainer />}
      {booting && <BootOverlay />}
    </Fragment>
  );
}

export default App;
